<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="主播手机号：">
            <el-input v-model="query.anchorPhone" placeholder="请输入手机号" clearable size="small" />
          </el-form-item>
          <el-form-item label="直播身份：">
            <el-select v-model="query.anchorPosition" placeholder="全部" clearable size="small">
              <el-option label="总监" value="总监"></el-option>
              <el-option label="营销经理" value="营销经理"></el-option>
              <el-option label="大区经理" value="大区经理"></el-option>
              <el-option label="地区经理" value="地区经理"></el-option>
              <el-option label="县区经理" value="县区经理"></el-option>
              <el-option label="研修班" value="研修班"></el-option>
              <el-option label="体验班" value="体验班"></el-option>
              <el-option label="普通人员" value="普通人员"></el-option>
              <el-option label="技术总监" value="技术总监"></el-option>
              <el-option label="督导" value="督导"></el-option>
              <el-option label="技术老师" value="技术老师"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属大区：">
            <el-select
              v-model="query.areaUserId"
              filterable
              remote
              clearable
              size="small"
              placeholder="请输入大区经理姓名/手机号搜索"
              :remote-method="searchAreaManager"
              :loading="areaManagerLoading"
            >
              <el-option v-for="item in areaManagerOptions" :key="item.id" :label="item.realName + '(' + item.userPho + ')'" :value="item.id" />
            </el-select>
          </el-form-item>
          <el-form-item label="区域：">
            <el-cascader
              v-model="addressValue"
              :options="addressOptions"
              :props="cascaderProps"
              placeholder="请选择省/市/区（支持多选）"
              clearable
              size="small"
              collapse-tags
              @change="handleAddressChange"
              style="width: 280px;"
            />
          </el-form-item>
          <el-form-item label="用户身份：">
            <el-select
              v-model="query.userPositions"
              placeholder="全部"
              clearable
              size="small"
              multiple
              collapse-tags
            >
              <el-option-group v-for="group in identityOptions" :key="group.label" :label="group.label">
                <el-option v-for="item in group.options" :key="item.value" :label="item.label" :value="item.label" />
              </el-option-group>
            </el-select>
          </el-form-item>
          <el-form-item label="直播编号：">
            <el-input v-model="query.liveCode" placeholder="请输入直播编号" clearable size="small" />
          </el-form-item>
          <el-form-item label="直播主题：">
            <el-input v-model="query.title" placeholder="请输入直播主题" clearable size="small" />
          </el-form-item>
          <el-form-item label="直播类型：">
            <el-select v-model="query.liveType" placeholder="全部" clearable size="small">
              <el-option label="全部" :value="undefined"></el-option>
              <el-option label="带货竖屏直播" :value="1"></el-option>
              <el-option label="培训横屏直播" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="打赏类型：">
            <el-select v-model="query.rewardType" placeholder="全部" clearable size="small">
              <el-option label="全部" :value="undefined"></el-option>
              <el-option label="现金" :value="1"></el-option>
              <el-option label="小礼币" :value="2"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item>
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <div class="btn-box">
          <el-button type="primary" size="mini" @click="handleCreate" icon="el-icon-plus">创建直播预告</el-button>
          <el-button type="primary" size="mini" @click="handleExport" plain>导出</el-button>
          <!-- <el-button type="danger" size="mini" @click="handleDeleteBatch" plain>批量删除</el-button> -->
        </div>
      </div>
      <!-- 直播状态过滤tabs -->
      <div class="status-tabs mb10">
        <el-tabs v-model="activeStatus" @tab-click="handleStatusChange">
          <el-tab-pane label="直播预告" name="0"></el-tab-pane>
          <el-tab-pane label="直播中" name="1"></el-tab-pane>
          <el-tab-pane label="直播暂停" name="2"></el-tab-pane>
        </el-tabs>
      </div>
      <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange" :row-key="getRowKey">
        <el-table-column label="直播间" prop="livePO.id" align="center" fixed="left"  :formatter="LiveTitleFormatter" />
        <el-table-column label="主播姓名" prop="userPO.realName" align="center" fixed="left" />
        <el-table-column label="主播身份" prop="liveAnchorPO.position" align="center" />
        <el-table-column label="主播手机号" prop="userPO.userPho" align="center" />
        <el-table-column label="直播类型" prop="liveType" align="center">
          <template slot-scope="{row}">
            {{ row.livePO.liveType === 1 ? '带货竖屏直播' : row.livePO.liveType === 2 ? '培训横屏直播' : '-' }}
          </template>
        </el-table-column>
        <el-table-column label="直播主图" prop="liveImg" align="center">
          <template slot-scope="{row}">
            <el-image style="width: 50px; height: 50px" :src="row.livePO.liveImg" :preview-src-list="[row.livePO.liveImg]"></el-image>
          </template>
        </el-table-column>
        <el-table-column v-if="showStreamColumn" label="推流链接" prop="pushRtmpUri" align="center">
          <template slot-scope="{row}">
            <div v-if="row.livePO.state!=0" style="display: flex; align-items: center; justify-content: center;">
              <span style="margin-right: 8px; max-width: 200px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{ row.livePO.pushRtmpUri }}</span>
              <el-button type="text" @click="copy(row.livePO.pushRtmpUri)">复制</el-button>
            </div>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="虚拟观看人数" prop="livePO.lookUserVirtualcount" align="center" />
        <el-table-column label="直播间观看人数" prop="livePO.lookUserCount" align="center">
          <template slot-scope="{row}">
            <el-link v-if="row.livePO.state!=0" type="primary" @click="handleViewers(row)">{{ row.livePO.lookUserCount || 0}}</el-link>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="管理员人数" prop="adminCount" align="center">
          <template slot-scope="{row}">
            <el-link type="primary" @click="handleAdmin(row)">{{ row.livePO.adminCount || 0}}</el-link>
          </template>
        </el-table-column> -->
        <!-- <el-table-column label="直播打赏人数" prop="livePO.rewardUserCount" align="center">
          <template slot-scope="{row}">
            <el-link v-if="row.livePO.state!=0" type="primary" @click="handleReward(row)">{{ row.livePO.rewardUserCount || 0}}</el-link>
            <span v-else>-</span>
          </template>
        </el-table-column> -->
        <el-table-column label="充值订单" prop="livePO.tuitionOrderCount" align="center" />
        <el-table-column label="余额商城订单" prop="liveAnchorPO.yueOrderCount" align="center" />
        <el-table-column label="秒杀订单" prop="liveAnchorPO.killOrderCount" align="center" />
        <el-table-column label="创建时间" prop="livePO.createdTime" align="center" min-width="180" />
        <!-- <el-table-column label="预告开播时间" prop="livePO.startTime" align="center">
          <template slot-scope="{row}">
            <span v-if="row.livePO.state===0">{{ row.livePO.startTime }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column> -->
        <el-table-column label="开播时间" prop="livePO.startTime" align="center" min-width="180" />
        <el-table-column label="直播权限" prop="liveAuthPO" align="center">
          <template slot-scope="{row}">
            <el-link v-if="row.liveAuthPO" type="primary" @click="handleViewPermission(row)">
              {{ getPermissionText(row.liveAuthPO) }}
            </el-link>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="180" fixed="right">
          <template slot-scope="{row}">
            <el-button type="text" v-if="row.livePO.state===0" @click="handleUpdate(row)">修改</el-button>
            <el-button type="text" v-if="row.livePO.state!=0" @click="handleOpenConsole(row)">控制台</el-button>
            <el-button type="text" v-if="row.livePO.state===0" @click="handleForceDown(row)">取消预告</el-button>
            <el-button type="text" v-if="row.livePO.state!=0"  @click="handleForceDown(row)">强制下播</el-button>
            <el-button type="text" @click="handlePushRemind(row)">推送提醒</el-button>
            <el-button type="text" v-if="row.livePO.liveType === 1" @click="handleLiveGoods(row)">直播商品</el-button>
            <!-- <el-button type="text" @click="handleEnable(row)" v-if="row.livePO.liveType === 2">连麦</el-button> -->
            <el-dropdown @command="handleCommand">
              <el-button type="text" size="mini">更多<i class="el-icon--right el-icon-arrow-down"></i></el-button>
              <el-dropdown-menu slot="dropdown">
                 <el-dropdown-item :command="beforeHandleCommand(row,1)">直播福袋</el-dropdown-item>
               <!-- <el-dropdown-item :command="beforeHandleCommand(row,2)">充值活动</el-dropdown-item> -->
                <el-dropdown-item :command="beforeHandleCommand(row,3)">虚拟人数</el-dropdown-item>
                <el-dropdown-item :command="beforeHandleCommand(row,4)">直播间观看人数</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
    <!-- 新建表单 -->
    <live-add ref="liveAdd" @created="doQueryList({})" />
    <viewers-vue ref="viewersVue" @created="doQueryList({})" />
    <reward-vue ref="rewardVue" @created="doQueryList({})" />
    <admin-vue ref="adminVue" @created="doQueryList({})" />
    <recharge-vue ref="rechargeVue" @created="doQueryList({})" />
    <live-goods-vue ref="liveGoods" @created="doQueryList({})" />
    <lucky-bag-vue ref="luckyBag" @created="doQueryList({})" />
    
    <!-- 虚拟人数弹窗 -->
    <el-dialog
      title="虚拟人数"
      :visible.sync="virtualCountDialogVisible"
      width="400px"
      :before-close="handleCloseVirtualDialog"
    >
      <el-form :model="virtualCountForm" :rules="virtualCountRules" ref="virtualCountForm" label-width="100px">
        <el-form-item label="虚拟人数" prop="virtualCount" required>
          <el-input
            v-model="virtualCountForm.virtualCount"
            placeholder="请输入直播间虚拟人数"
            type="number"
            :min="0"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCloseVirtualDialog">取消</el-button>
        <el-button type="primary" @click="handleConfirmVirtualCount" :loading="virtualCountLoading">确认</el-button>
      </div>
    </el-dialog>
    
    <!-- 观看权限详情弹窗 -->
    <el-dialog
      title="观看权限详情"
      :visible.sync="permissionDialogVisible"
      width="600px"
    >
      <el-descriptions :column="1" border>
        <el-descriptions-item label="权限类型">
          {{ getPermissionTypeText(currentPermission && currentPermission.authType) }}
        </el-descriptions-item>
        
        <el-descriptions-item v-if="currentPermission && currentPermission.authType === 2" label="观看密码">
          {{ currentPermission.authTwo || '-' }}
        </el-descriptions-item>
        
        <el-descriptions-item v-if="currentPermission && currentPermission.authType === 3" label="观看人员">
          <div v-if="currentPermission.authThreeStr">
            {{ formatAuthThreeDetail(currentPermission.authThreeStr) }}
          </div>
          <span v-else-if="currentPermission.authThree">
            {{ currentPermission.authThree.split(',').length }} 人
          </span>
          <span v-else>-</span>
        </el-descriptions-item>
        
        <el-descriptions-item v-if="currentPermission && currentPermission.authType === 4" label="观看身份">
          <div v-if="currentPermission.authFour">
            <div v-for="group in formatAuthFour(currentPermission.authFour)" :key="group.type">
              <div style="margin-bottom: 8px;">
                <strong>{{ group.typeText }}：</strong>
                <span v-for="(item, index) in group.roles" :key="index">
                  {{ item.name }}
                  <span v-if="index < group.roles.length - 1">、</span>
                </span>
              </div>
            </div>
          </div>
          <span v-else>-</span>
        </el-descriptions-item>
        
        <el-descriptions-item v-if="currentPermission && currentPermission.authType === 5" label="观看标签">
          <div v-if="currentPermission.authFiveStr" class="tag-display-container">
            <div v-for="(group, groupIndex) in formatAuthFiveDetail(currentPermission.authFiveStr)" :key="groupIndex" style="margin-bottom: 10px;">
              <div class="tag-group-name" style="font-weight: 500; margin-bottom: 5px;">{{ group.name }}：</div>
              <div class="tag-items" style="display: flex; flex-wrap: wrap; gap: 8px;">
                <div v-for="tag in group.tags" :key="tag.id" class="tag-item" style="display: inline-flex; align-items: center; gap: 4px;">
                  <img v-if="tag.image" :src="tag.image" style="width: 20px; height: 20px; object-fit: contain;" />
                  <span>{{ tag.name || `标签${tag.id}` }}</span>
                </div>
              </div>
            </div>
          </div>
          <div v-else-if="currentPermission.authFive">
            {{ currentPermission.authFive }}
          </div>
          <span v-else>-</span>
        </el-descriptions-item>
      </el-descriptions>
      <div slot="footer" class="dialog-footer">
        <el-button @click="permissionDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import liveManageApi from '@/api/live/liveManage'
import Pagination from '@/components/Pagination'
import liveAdd from '@/views/live/livePreview/add'
import viewersVue from './viewers'
import rewardVue from './rewardRecord'
import adminVue from './adminVue'
import rechargeVue from './recharge'
import liveGoodsVue from './add'
import luckyBagVue from './luckyBag'
import { Subtr } from '@/utils/index'
export default {
  components: {
    Pagination,
    liveAdd,
    liveGoodsVue,
    viewersVue,
    rewardVue,
    adminVue,
    rechargeVue,
    luckyBagVue
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
        state: 0 // 默认设置为直播预告
      },
      selectItems: [],
      activeStatus: '0', // 当前选中的直播状态tab，默认为直播预告
      showStreamColumn: false, // 控制推流链接列显示
      // 区域级联选择器
      addressValue: [],
      addressOptions: [],
      cascaderProps: {
        value: 'regionCode',
        label: 'regionName',
        children: 'child',
        multiple: true,
        checkStrictly: false,
        emitPath: true
      },
      // 用户身份选项（分组）
      identityOptions: [],
      // 所属大区（大区经理远程搜索）
      areaManagerLoading: false,
      areaManagerOptions: [],
      // 虚拟人数弹窗相关
      virtualCountDialogVisible: false,
      virtualCountLoading: false,
      currentLiveRow: null, // 当前操作的直播行数据
      virtualCountForm: {
        virtualCount: ''
      },
      virtualCountRules: {
        virtualCount: [
          { required: true, message: '请输入虚拟人数', trigger: 'blur' },
          { 
            validator: (rule, value, callback) => {
              const num = Number(value)
              if (isNaN(num)) {
                callback(new Error('请输入有效的数字'))
              } else if (num < 0) {
                callback(new Error('虚拟人数不能小于0'))
              } else {
                callback()
              }
            }, 
            trigger: 'blur' 
          }
        ]
      },
      // 权限详情弹窗相关
      permissionDialogVisible: false,
      currentPermission: null
    }
  },
  created() {
    // 初始化推流链接列显示状态
    this.showStreamColumn = this.query.state !== 0
    this.doQueryList({ pageNo: 1 })
    this.loadAddressData()
    this.loadIdentityData()
  },
  methods: {
    /**
     * 获取行唯一标识
     */
    getRowKey(row) {
      return row.livePO ? row.livePO.id : null
    },
    LiveTitleFormatter(row) {
      try {
        if (!row || !row.livePO) return '-'
        return `${row.livePO.id} - ${row.livePO.title}`
      } catch (error) {
        console.error('格式化直播间标题失败:', error, row)
        return '-'
      }
    },
    handleLiveGoods(row) {
      this.$refs.liveGoods.handleShow(row)
    },
    handleViewers(row) {
      this.$refs.viewersVue.handleShow(row)
    },
    handleReward(row) {
      this.$refs.rewardVue.handleShow(row)
    },
    handleAdmin(row) {
      this.$refs.adminVue.handleShow(row)
    },
    copy(url) {
      if (navigator.clipboard && window.isSecureContext) {
        // 使用现代浏览器的 Clipboard API
        navigator.clipboard.writeText(url).then(() => {
          this.$message.success('复制成功')
        }).catch(() => {
          this.$message.error('复制失败')
        })
      } else {
        // 降级方案：使用传统的 document.execCommand
        const textArea = document.createElement('textarea')
        textArea.value = url
        textArea.style.position = 'fixed'
        textArea.style.left = '-999999px'
        textArea.style.top = '-999999px'
        document.body.appendChild(textArea)
        textArea.focus()
        textArea.select()
        try {
          document.execCommand('copy')
          this.$message.success('复制成功')
        } catch (err) {
          this.$message.error('复制失败')
        }
        document.body.removeChild(textArea)
      }
    },
    handleFilter() {
      this.query = {
        pageNo: 1,
        pageSize: 10,
        state: 0 // 默认设置为直播预告
      }
      this.activeStatus = '0' // 重置状态tab为直播预告
      this.showStreamColumn = false // 重置推流链接列显示状态
      this.addressValue = [] // 重置区域选择器
      this.doQueryList({ pageNo: 1, pageSize: 10 })
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 触发后端排序
     */
    sortChange({ prop, order }) {
      const sortKeyMap = {
        'createdTime': 'createdTimeSortSign',
        'operatedTime': 'operatedTimeSortSign'
      }
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k]
        if (k !== prop) {
          this.query[sortKey] = null
        } else {
          if (order === 'ascending') {
            this.query[sortKey] = 1
          } else {
            this.query[sortKey] = -1
          }
        }
      }
      this.doQueryList({})
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 导出占位方法，防止未定义报错
     */
    handleExport() {
      this.$message.info('导出功能开发中')
    },
    /**
     * 处理直播状态tab切换
     */
    handleStatusChange(tab) {
      // 设置对应的state值
      this.query.state = parseInt(tab.name)
      // 根据状态控制推流链接列显示
      this.showStreamColumn = this.query.state !== 0
      // 重新查询数据
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      // 处理用户身份多选值转换为逗号分隔字符串
      const params = { ...this.query }
      if (Array.isArray(params.userPositions)) {
        params.userPositions = params.userPositions.join(',') || undefined
      }
      if (!params.areaUserId) {
        params.areaUserId = undefined
      }
      //state 0 预约直播 1 直播中 2 暂停直播 3结束直播 4取消直播
      this.listLoading = true
      return liveManageApi.fetchListLive(params)
        .then(data => {
         
          
          this.list = data.data.list
          this.total = data.data.total
          
          
          
          
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    /**
     * 打开控制台
     */
    handleOpenConsole(row) {

      // 尝试不同的字段名      const playHlsUri = row.livePO.play_hls_uri || row.livePO.playHlsUri || ''
      // const playFlvUri =row.livePO.playFlvUri || ''
      // const playWebRtc = row.livePO.playWebRtc || ''
      
      // console.log('最终播放地址:', {
      //   playFlvUri,
      //   playWebRtc
      // })
      
      this.$router.push({
        path: '/live/liveStreaming/console',
        query: { 
          id: row.livePO.id,
          // title: row.livePO.title,
          // anchorInfo: `${row.userPO.realName}-${row.liveAnchorPO.position}-${row.userPO.userPho}`,
          // viewerCount: row.livePO.viewerCount || 0,
          // startTime: row.livePO.startTime,
          // //viewPermission: row.livePO.viewPermission || '公开观看',
          // playFlvUri: playFlvUri,
          // playWebRtc: playWebRtc
        }
      })
    },
    /**
     * 强制下播/取消预告
     */
    handleForceDown(row) {
      const isCancelForecast = row.livePO.state === 0
      const confirmText = isCancelForecast ? '是否确认取消预告' : '正在直播中，是否确认强制下播'
      const successText = isCancelForecast ? '取消预告成功' : '强制下播成功'
      const stateValue = isCancelForecast ? 4 : 3
      
      return this.$common.confirm(confirmText)
      .then(() => {
          return liveManageApi.updateLiveState({
            liveId: row.livePO.id,
            state: stateValue
          })
        })
        .then(() => {
          this.$common.showMsg('success', successText)
          return this.doQueryList({ pageNo: 1 })
        })
        .catch(() => {
          const errorText = row.livePO.state === 0 ? '取消预告失败' : '强制下播失败'
          this.$common.showMsg('error', errorText)
        })
    },
    /**
     * 手动推送直播提醒（全员极光推送）
     *
     * 后端有个开播前 10 分钟自动推的定时任务，但那是一次性窗口：运营临时改期、
     * 临时加播、或者调度进程那会儿在重启，这场直播就一条提醒都发不出去。
     * 列表页留这个按钮给运营手动补一发。
     *
     * 这是全员推送、发出去撤不回来，所以必须二次确认，且确认文案里带上直播标题，
     * 避免运营点错行给错的直播发了全员推送。
     */
    handlePushRemind(row) {
      const title = row.livePO && row.livePO.title
      if (!title) {
        this.$message.error('直播标题为空')
        return
      }
      this.$confirm(`确认向全部用户推送「${title}」的直播提醒吗？`, '推送直播提醒', {
        confirmButtonText: '确认推送',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        liveManageApi.pushRemind(row.livePO.id).then(() => {
          this.$message.success('推送已发出')
        }).catch(() => {
          this.$message.error('推送失败')
        })
      }).catch(() => {})
    },
    /**
     * 删除单条记录
     */
    handleDeleteSingle(row) {
      return this.$common.confirm('是否确认删除')
        .then(() => liveManageApi.deleteById(row.id))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    /**
     * 批量删除记录
     */
    handleDeleteBatch() {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择')
        return
      }
      return this.$common.confirm('是否确认删除')
        .then(() => liveManageApi.deleteBatchLive(this.selectItems.map(row => row.id)))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    beforeHandleCommand(row, command) {
      return {
        'row': row,
        'command': command
      }
    },
    handleCommand(command) {
      if (command.command === 1) {
        this.$refs.luckyBag.handleShow(command.row)
      } else if (command.command === 2) {
        this.$refs.rechargeVue.handleShow(command.row)
      } else if (command.command === 3) {
        this.handleVirtualCount(command.row)
      }else if(command.command === 4) {
        this.$router.push({
        path: '/live/liveView',
        query: { liveId: command.row.livePO.id }
      })

      }
    },
    handleBatchState(ids, type) {
      let txt = type === 1 ? '确认将选中批量启用？' : '确认将选中批量禁用？'
      this.$common.confirm(txt).then(() => liveManageApi.setIsEnableBatch({ ids: ids, isEnable: type ? true : false }))
        .then(() => {
          this.$common.showMsg('success', '操作成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    changeSwitch(row) {
      liveManageApi.setIsEnable({ id: row.id, isEnable: row.isEnable }).then(() => {
        this.$common.showMsg('success', '操作成功')
      })
    },
    /**
     * 打开新建表单
     */
    handleCreate(row) {
      this.$refs.liveAdd.handleCreate(row)
    },
    /**
     * 打开查看表单
     */
    handleShow(row) {
      this.$emit('handleShow', row, 2)
    },
    /**
     * 打开编辑表单
     */
    handleUpdate(row) {
      this.$refs.liveAdd.handleUpdate(row)
    },
    
    /**
     * 打开虚拟人数弹窗
     */
    handleVirtualCount(row) {
      this.currentLiveRow = row
      // 设置当前虚拟人数到表单中
      this.virtualCountForm.virtualCount = row.livePO.lookUserVirtualcount || 0
      this.virtualCountDialogVisible = true
    },
    
    /**
     * 关闭虚拟人数弹窗
     */
    handleCloseVirtualDialog() {
      this.virtualCountDialogVisible = false
      this.virtualCountForm.virtualCount = ''
      this.currentLiveRow = null
      // 清除表单验证状态
      if (this.$refs.virtualCountForm) {
        this.$refs.virtualCountForm.clearValidate()
      }
    },
    
    /**
     * 确认设置虚拟人数
     */
    handleConfirmVirtualCount() {
      this.$refs.virtualCountForm.validate((valid) => {
        if (valid) {
          this.virtualCountLoading = true
          
          // 调用API设置虚拟人数
          liveManageApi.updateVirtualCount({
            liveId: this.currentLiveRow.livePO.id,
            virtualCount: parseInt(this.virtualCountForm.virtualCount)
          }).then(() => {
            this.$message.success('虚拟人数设置成功')
            this.handleCloseVirtualDialog()
            // 刷新列表
            this.doQueryList({})
          }).catch((error) => {
            console.error('设置虚拟人数失败:', error)
            this.$message.error('设置虚拟人数失败')
          }).finally(() => {
            this.virtualCountLoading = false
          })
        }
      })
    },
    
    /**
     * 获取权限类型文本
     */
    getPermissionTypeText(authType) {
      const typeMap = {
        1: '所有人观看',
        2: '密码观看',
        3: '部分人观看',
        4: '部分人身份观看',
        5: '部分标签观看'
      }
      return typeMap[authType] || '-'
    },
    
    /**
     * 获取权限文本内容（列表只显示权限类型）
     */
    getPermissionText(liveAuthPO) {
      try {
        if (!liveAuthPO) return '-'
        return this.getPermissionTypeText(liveAuthPO.authType)
      } catch (error) {
        console.error('获取权限文本失败:', error, liveAuthPO)
        return '-'
      }
    },
    
    /**
     * 格式化authThreeStr详细信息用于弹窗显示
     */
    formatAuthThreeDetail(authThreeStr) {
      if (!authThreeStr) return '-'
      
      try {
        // 如果是JSON字符串，解析它
        const data = typeof authThreeStr === 'string' ? JSON.parse(authThreeStr) : authThreeStr
        
        if (Array.isArray(data) && data.length > 0) {
          // 显示所有人员信息
          const peopleList = data.map(item => {
            const name = item.realName || item.name || ''
            const phone = item.userPho || item.phone || ''
            const position = item.position || ''
            return `${name}(${phone}${position ? '-' + position : ''})`
          }).join('、')
          return peopleList
        }
        return '-'
      } catch (e) {
        console.error('解析authThreeStr详细信息失败:', e)
        return '-'
      }
    },
    
    /**
     * 格式化authFiveStr详细信息用于弹窗显示（返回数据数组供模板渲染）
     */
    formatAuthFiveDetail(authFiveStr) {
      if (!authFiveStr) return []
      
      try {
        // 如果是JSON字符串，解析它
        const data = typeof authFiveStr === 'string' ? JSON.parse(authFiveStr) : authFiveStr
        
        if (Array.isArray(data) && data.length > 0) {
          // 处理标签组数据结构: [{id: 2, name: "标签2组", tags: [{id: 3, name: "测试1", image: "..."}, {id: 4}]}]
          return data.map(group => {
            const groupName = group.name || group.groupName || `标签组${group.id}`
            
            // 处理tags数组，保留完整的标签信息（包括图片）
            const tags = (group.tags && Array.isArray(group.tags) && group.tags.length > 0) 
              ? group.tags.map(tag => {
                  // 标签名称：优先使用name，如果没有则显示ID
                  const tagName = tag.name || tag.tagName || `标签${tag.id}`
                  
                  return {
                    id: tag.id,
                    name: tagName,
                    image: tag.image || tag.tagImg || tag.tagImage || null
                  }
                })
              : []
            
            return {
              id: group.id,
              name: groupName,
              tags: tags
            }
          })
        }
        return []
      } catch (e) {
        console.error('解析authFiveStr详细信息失败:', e)
        return []
      }
    },
    
    /**
     * 查看权限详情
     */
    handleViewPermission(row) {
    
      
      this.currentPermission = row.liveAuthPO || null
      this.permissionDialogVisible = true
    },
    
    /**
     * 加载区域级联数据
     */
    loadAddressData() {
      liveManageApi.getAddressTreeList({})
        .then(response => {
          if (response.code === '0' && response.data) {
            this.addressOptions = this.limitAddressLevel(response.data, 3)
          }
        })
        .catch(error => {
          console.error('加载区域数据失败:', error)
        })
    },
    /**
     * 限制地址数据层级
     */
    limitAddressLevel(data, maxLevel, currentLevel = 1) {
      if (!data || !Array.isArray(data)) return []
      return data.map(item => {
        const newItem = { ...item }
        if (currentLevel >= maxLevel) {
          delete newItem.child
        } else if (newItem.child && Array.isArray(newItem.child)) {
          newItem.child = this.limitAddressLevel(newItem.child, maxLevel, currentLevel + 1)
        }
        return newItem
      })
    },
    /**
     * 区域级联选择器变化处理（多选）
     */
    handleAddressChange(value) {
      if (value && value.length > 0) {
        const provinceCodes = new Set()
        const cityCodes = new Set()
        const areaCodes = new Set()
        value.forEach(path => {
          if (path.length >= 1) provinceCodes.add(path[0])
          if (path.length >= 2) cityCodes.add(path[1])
          if (path.length >= 3) areaCodes.add(path[2])
        })
        this.query.addrProvinceCodes = Array.from(provinceCodes).join(',') || undefined
        this.query.addrCityCodes = Array.from(cityCodes).join(',') || undefined
        this.query.addrAreaCodes = Array.from(areaCodes).join(',') || undefined
      } else {
        this.query.addrProvinceCodes = undefined
        this.query.addrCityCodes = undefined
        this.query.addrAreaCodes = undefined
      }
    },
    /**
     * 加载用户身份数据（分组）
     */
    loadIdentityData() {
      liveManageApi.getAllIdentity().then(({ data }) => {
        if (data && Array.isArray(data)) {
          const grouped = {}
          data.forEach(item => {
            const typeKey = item.type !== undefined ? item.type : 'other'
            if (!grouped[typeKey]) {
              let typeLabel = '其他'
              if (typeKey === 1 || typeKey === '1') typeLabel = '技术线'
              else if (typeKey === 2 || typeKey === '2') typeLabel = '业务线'
              else if (typeKey === 3 || typeKey === '3') typeLabel = '其他'
              grouped[typeKey] = { label: typeLabel, options: [] }
            }
            grouped[typeKey].options.push({
              value: item.id,
              label: item.name || ''
            })
          })
          // 按 type 排序：技术线、业务线、其他
          const order = { '1': 0, '2': 1 }
          this.identityOptions = Object.entries(grouped)
            .sort((a, b) => (order[a[0]] != null ? order[a[0]] : 2) - (order[b[0]] != null ? order[b[0]] : 2))
            .map(([, v]) => v)
        } else {
          this.identityOptions = []
        }
      }).catch(err => {
        console.error('获取身份列表失败:', err)
        this.identityOptions = []
      })
    },
    /**
     * 远程搜索大区经理
     */
    searchAreaManager(query) {
      if (query !== '') {
        this.areaManagerLoading = true
        liveManageApi.searchUser({ keyword: query }).then(({ data }) => {
          // 只保留大区经理
          this.areaManagerOptions = (data || []).filter(
            user => user.position === '大区经理'
          )
        }).catch(() => {
          this.areaManagerOptions = []
        }).finally(() => {
          this.areaManagerLoading = false
        })
      } else {
        this.areaManagerOptions = []
      }
    },
    /**
     * 格式化身份观看权限
     * @returns {Array} 返回分组后的数据 [{type: 1, typeText: '技术线', roles: [...]}, ...]
     */
    formatAuthFour(authFour) {
      if (!authFour) return []
      try {
        // 尝试解析 JSON 字符串
        const authData = typeof authFour === 'string' ? JSON.parse(authFour) : authFour
        
        if (!Array.isArray(authData) || authData.length === 0) {
          return []
        }
        
        // 按照 type 分组：1=技术线，2=业务线
        const techLine = authData.filter(item => item.type === 1)
        const businessLine = authData.filter(item => item.type === 2)
        const otherLine = authData.filter(item => item.type === 3)
        const result = []
        
        // 技术线
        if (techLine.length > 0) {
          result.push({
            type: 1,
            typeText: '技术线',
            roles: techLine
          })
        }
        
        // 业务线
        if (businessLine.length > 0) {
          result.push({
            type: 2,
            typeText: '业务线',
            roles: businessLine
          })
        }
          // 其它
          if (otherLine.length > 0) {
          result.push({
            type: 3,
            typeText: '其它',
            roles: otherLine
          })
        }
        
        return result
      } catch (e) {
        
        return []
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.status-tabs {
  margin-bottom: 10px;
  
  ::v-deep .el-tabs__header {
    margin: 0;
  }
  
  ::v-deep .el-tabs__nav-wrap {
    padding: 0;
  }
  
  ::v-deep .el-tabs__item {
    padding: 0 20px;
    height: 40px;
    line-height: 40px;
  }
  
  ::v-deep .el-tabs__item.is-active {
    color: #409EFF;
    font-weight: 500;
  }
}
</style>
